import { UserManager } from 'oidc-client-ts';
import { baseURL, frontUrl } from 'app/client';

/**
 * UserManager OIDC partagé : construit ici (et non implicitement par
 * react-oidc-context) pour que l'impersonation puisse basculer la session
 * hors du cycle React (storeUser / signinSilent). index.tsx le passe à
 * AuthProvider — comportement identique à l'ancienne config par props.
 */
export const userManager = new UserManager({
  authority: `${baseURL}`,
  client_id: 'EspacePro_App',
  redirect_uri: `${frontUrl}/authentication/callback`,
  silent_redirect_uri: `${frontUrl}/authentication/silent-callback`,
  scope: 'openid profile email BackOffice offline_access',
  response_type: 'code',
  automaticSilentRenew: true,
  silentRequestTimeoutInSeconds: 10,
  includeIdTokenInSilentRenew: true,

  accessTokenExpiringNotificationTimeInSeconds: 300, // 5 minutes avant expiration
  checkSessionIntervalInSeconds: 60, // Vérifier la session toutes les minutes
});
